exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".label-name[data-v-a9e1bc38]{font-weight:700;font-size:18px}.item-container[data-v-a9e1bc38]{display:flex;margin:0 20px;padding:20px 0;border-bottom:2px solid #f5f5f5}.flex-between[data-v-a9e1bc38]{display:flex;justify-content:space-between}.full-width[data-v-a9e1bc38]{width:100%}.margin-right[data-v-a9e1bc38]{margin-right:1em}.label-value .link[data-v-a9e1bc38]{font-weight:700;color:#ec1c24}.hide-border[data-v-a9e1bc38]{border-bottom:none}.flip[data-v-a9e1bc38]{transform:scaleX(-1)}.flex-between.label-value[data-v-a9e1bc38]{align-items:center}.disabled [data-v-a9e1bc38]{color:#ddd!important}.error [data-v-a9e1bc38]{color:#ff3860!important}@media (min-width:0px) and (max-width:320px){.link[data-v-a9e1bc38]{font-size:10pt}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-a9e1bc38","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/common/BaseActionItem.vue
// module id = /wHp
// module chunks = 18